var render = function render(){var _vm=this,_c=_vm._self._c;return _c('cs-preloader-overlay',{attrs:{"loading":_vm.loading}},[(_vm.deal)?[_c(_vm.currentView,{tag:"component",attrs:{"deal":_vm.deal,"language":_vm.getLanguage,"payment":_vm.payment,"project":_vm.project},on:{"update":_vm.loadDeal}})]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }